export const remapObjectArrayToFilterList = (input, idKey, labelKey) =>
  input?.map((item) => ({
    id: item[idKey],
    label: item[labelKey].toString(),
  }));

export const mapEnumsToFilterList = (enumArray) => remapObjectArrayToFilterList(enumArray, 'id', 'name');
